"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _goods = require("@/api/marketingFunction/superSubsidyV2/goods");
var _platformOption = require("@/utils/platformOption");
var _copyText = require("@/utils/copyText");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 补贴方式：1 固定金额、2 百分比（与后端 SuperSubConstants 取值一致）
var SUBSIDY_TYPE_AMT = 1;
var SUBSIDY_TYPE_RATE = 2;
// 补贴百分比上限（百分制，含）
var SUBSIDY_RATE_MAX = 100;

// 商品表单字段初始值；新增、重置、关闭均取新对象，避免共享引用
function createGoodsForm() {
  return {
    id: null,
    platformCode: 'TB',
    activityId: null,
    goodsCommand: '',
    goodsId: '',
    title: '',
    subTitle: '',
    goodsPic: '',
    originPrice: '',
    couponPrice: '',
    commission: '',
    stockTotal: '',
    perLimit: '',
    subsidyType: SUBSIDY_TYPE_AMT,
    subsidyAmt: '',
    subsidyRate: '',
    sortNo: '',
    goodsStatus: 1,
    timeArray: []
  };
}

/**
 * 超级补贴商品新增/编辑弹窗。
 * 编辑不支持更换商品（渠道、活动、口令、上架数量禁用），detail 由父级详情接口取到后传入。
 */
var _default2 = exports.default = {
  name: 'SuperSubsidyV2GoodsFormDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // add 新增 / edit 编辑
    eventsType: {
      type: String,
      default: 'add'
    },
    activityOption: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 编辑态商品详情；新增态为 null
    detail: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    var _this = this;
    var validateGoodsCommand = function validateGoodsCommand(rule, value, callback) {
      // 编辑不支持更换商品，口令/链接不再校验
      if (!_this.isEdit && !value) {
        callback(new Error('请输入商品口令/链接'));
        return;
      }
      callback();
    };
    var validateSubsidyAmt = function validateSubsidyAmt(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入补贴金额'));
        return;
      }
      var amt = Number(value);
      if (!(amt > 0)) {
        callback(new Error('补贴金额必须大于0'));
        return;
      }
      // 券后价取自解析结果，与后端校验基准同源
      if (_this.ruleForm.couponPrice !== '' && amt > Number(_this.ruleForm.couponPrice)) {
        callback(new Error('补贴金额不得大于券后价'));
        return;
      }
      callback();
    };
    var validateSubsidyRate = function validateSubsidyRate(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入补贴百分比'));
        return;
      }
      var rate = Number(value);
      // 「!(rate > 0)」同时拦截非数字输入
      if (!(rate > 0) || rate > SUBSIDY_RATE_MAX) {
        callback(new Error('补贴百分比须大于0且不超过100'));
        return;
      }
      callback();
    };
    return {
      platformOption: _platformOption.PLATFORM_OPTION,
      saveLoading: false,
      ruleForm: createGoodsForm(),
      rules: {
        platformCode: [{
          required: true,
          message: '请选择渠道',
          trigger: 'change'
        }],
        activityId: [{
          required: true,
          message: '请选择所属活动',
          trigger: 'change'
        }],
        goodsCommand: [{
          validator: validateGoodsCommand,
          trigger: 'blur'
        }],
        stockTotal: [{
          required: true,
          message: '请输入上架数量',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 1,
          message: '上架数量必须大于0',
          trigger: 'blur'
        }],
        perLimit: [{
          required: true,
          message: '请输入每人限购数量',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 1,
          message: '每人限购数量必须大于0',
          trigger: 'blur'
        }],
        subsidyAmt: [{
          validator: validateSubsidyAmt,
          trigger: 'blur'
        }],
        subsidyRate: [{
          validator: validateSubsidyRate,
          trigger: 'blur'
        }],
        sortNo: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '排序必须为数字',
          trigger: 'blur'
        }],
        timeArray: [{
          required: true,
          message: '请选择上线时间',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    // 编辑态（渠道、活动、口令、上架数量锁定）
    isEdit: function isEdit() {
      return this.eventsType === 'edit';
    },
    // 百分比方式按当前券后价预估补贴金额；与后端一致向下取整到两位防超付，最终以保存时平台实时券后价为准
    subsidyAmtPreview: function subsidyAmtPreview() {
      var price = Number(this.ruleForm.couponPrice);
      var rate = Number(this.ruleForm.subsidyRate);
      if (!(price > 0) || !(rate > 0)) return null;
      return (Math.floor(Number((price * rate).toFixed(4))) / 100).toFixed(2);
    },
    // el-dialog 需要可写 visible，转成对父级的 .sync 更新
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    // 每次打开按当前模式填充：编辑回填详情，新增回到初始值
    visible: function visible(val) {
      if (!val) return;
      this.fillForm();
    }
  },
  methods: {
    // 打开时填充：新增取初始值，编辑回填详情
    fillForm: function fillForm() {
      if (!this.isEdit) {
        this.ruleForm = createGoodsForm();
        return;
      }
      var data = this.detail || {};
      this.ruleForm = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, createGoodsForm()), {}, {
        id: data.id,
        platformCode: data.platformCode,
        activityId: data.activityId,
        // 编辑回显解析入参留档的口令/链接（不可修改）
        goodsCommand: data.goodsCommand || '',
        goodsId: data.goodsId,
        title: data.title,
        subTitle: data.subTitle,
        goodsPic: data.goodsPic,
        originPrice: data.originPrice,
        couponPrice: data.couponPrice,
        commission: data.commission,
        stockTotal: data.stockTotal,
        perLimit: data.perLimit,
        // 老数据无补贴方式，按固定金额回显
        subsidyType: data.subsidyType || SUBSIDY_TYPE_AMT,
        subsidyAmt: data.subsidyAmt != null ? data.subsidyAmt : '',
        subsidyRate: data.subsidyRate != null ? data.subsidyRate : '',
        sortNo: data.sortNo,
        goodsStatus: data.goodsStatus,
        timeArray: data.startTime && data.endTime ? [data.startTime, data.endTime] : []
      });
    },
    // 复制商品ID
    copy: function copy(val) {
      (0, _copyText.copyText)(val);
    },
    // 切换渠道后原解析结果作废（渠道与商品ID须同源）
    onPlatformChange: function onPlatformChange() {
      if (this.isEdit) return;
      this.ruleForm.goodsId = '';
      this.ruleForm.title = '';
      this.ruleForm.goodsPic = '';
      this.ruleForm.originPrice = '';
      this.ruleForm.couponPrice = '';
      this.ruleForm.commission = '';
    },
    // 商品解析：渠道 + 口令/链接（或纯商品ID）
    onSearchGoods: function () {
      var _onSearchGoods = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res, data, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.ruleForm.goodsCommand) {
                _context.n = 1;
                break;
              }
              this.$message.error('请输入商品口令/链接');
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return (0, _goods.goodsSearch)({
                platformCode: this.ruleForm.platformCode,
                goodsCommand: this.ruleForm.goodsCommand
              });
            case 2:
              res = _context.v;
              data = res.data || {};
              if (data.goodsId) {
                _context.n = 3;
                break;
              }
              this.$message.error('未查询到有效商品信息，请检查后再试');
              return _context.a(2);
            case 3:
              this.ruleForm.goodsId = data.goodsId;
              this.ruleForm.title = data.title;
              this.ruleForm.goodsPic = data.goodsPic;
              this.ruleForm.originPrice = data.originPrice;
              this.ruleForm.couponPrice = data.couponPrice;
              this.ruleForm.commission = data.commission;
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.log(_t);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4]]);
      }));
      function onSearchGoods() {
        return _onSearchGoods.apply(this, arguments);
      }
      return onSearchGoods;
    }(),
    // 校验通过后二次确认再提交
    submitForm: function submitForm(formName) {
      var _this2 = this;
      if (!this.ruleForm.goodsId) {
        this.$message.error('请先搜索并确认商品信息后再尝试保存');
        return;
      }
      this.$refs[formName].validate(function (valid) {
        if (!valid) return;
        _this2.$confirm("\u662F\u5426\u786E\u8BA4".concat(_this2.isEdit ? '编辑' : '添加', "\u6B64\u5546\u54C1?"), '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this2.onSave();
        }).catch(function () {});
      });
    },
    // 保存：新增/编辑共用；编辑态后端不落口令（不支持换商品）
    onSave: function () {
      var _onSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var form, isRate, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!this.saveLoading) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.saveLoading = true;
              _context2.p = 2;
              form = this.ruleForm;
              isRate = form.subsidyType === SUBSIDY_TYPE_RATE;
              _context2.n = 3;
              return (0, _goods.goodsSave)({
                id: form.id || undefined,
                activityId: form.activityId,
                platformCode: form.platformCode,
                goodsCommand: form.goodsCommand || undefined,
                goodsId: form.goodsId,
                subTitle: form.subTitle || undefined,
                stockTotal: Number(form.stockTotal),
                perLimit: Number(form.perLimit),
                subsidyType: form.subsidyType,
                // 百分比方式由后端按实时券后价换算金额落库，只传对应方式的字段
                subsidyAmt: isRate ? undefined : Number(form.subsidyAmt),
                subsidyRate: isRate ? Number(form.subsidyRate) : undefined,
                sortNo: Number(form.sortNo),
                startTime: form.timeArray[0],
                endTime: form.timeArray[1],
                goodsStatus: form.goodsStatus
              });
            case 3:
              this.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              this.handleClose();
              this.$emit('saved');
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              console.log(_t2);
            case 5:
              _context2.p = 5;
              this.saveLoading = false;
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4, 5, 6]]);
      }));
      function onSave() {
        return _onSave.apply(this, arguments);
      }
      return onSave;
    }(),
    // 重置为初始值（同时清空校验态）
    resetForm: function resetForm(formName) {
      this.ruleForm = createGoodsForm();
      this.$refs[formName] && this.$refs[formName].resetFields();
    },
    // 关闭：重置表单并同步父级可见状态
    handleClose: function handleClose() {
      this.resetForm('ruleForm');
      this.dialogVisible = false;
    }
  }
};